export default {
    'create-warehouse': 'Create warehouse',
    'edit-warehouse': 'Edit warehouse',
    'warehouse-name': 'Warehouse name',
    notes: 'Notes',
    save: 'Save',
    cancel: 'Cancel',

    'delete-the-warehouse': 'Delete the warehouse',
    'are-you-sure-you-want-to-delete-the-warehouse': 'Do you want to delete this warehouse?',

    headers: {
        'no': 'No.',
        'warehouse-name': 'Warehouse name',
        'notes': 'Notes',
        'actions': 'Actions',
    }
}